export default __webpack_public_path__ + "static/media/Fast.bc8cd530.svg";